export const SlackColorIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={'SlackColorIcon'}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.86632 4C8.98186 4.00065 8.26606 4.71698 8.26671 5.59967C8.26606 6.48236 8.98251 7.1987 9.86697 7.19935H11.4672V5.60033C11.4679 4.71764 10.7514 4.0013 9.86632 4C9.86697 4 9.86697 4 9.86632 4ZM9.86632 8.26667H5.60026C4.7158 8.26732 3.99935 8.98365 4 9.86634C3.99869 10.749 4.71515 11.4654 5.59961 11.4667H9.86632C10.7508 11.466 11.4672 10.7497 11.4666 9.86699C11.4672 8.98365 10.7508 8.26732 9.86632 8.26667Z"
        fill="#36C5F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9998 9.86634C20.0004 8.98365 19.284 8.26732 18.3995 8.26667C17.5151 8.26732 16.7986 8.98365 16.7993 9.86634V11.4667H18.3995C19.284 11.466 20.0004 10.7497 19.9998 9.86634ZM15.7331 9.86634V5.59967C15.7337 4.71764 15.0179 4.0013 14.1335 4C13.249 4.00065 12.5326 4.71698 12.5332 5.59967V9.86634C12.5319 10.749 13.2484 11.4654 14.1328 11.4667C15.0173 11.466 15.7337 10.7497 15.7331 9.86634Z"
        fill="#2EB67D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1335 20C15.0179 19.9994 15.7344 19.2831 15.7337 18.4004C15.7344 17.5177 15.0179 16.8013 14.1335 16.8007H12.5332V18.4004C12.5325 19.2824 13.249 19.9987 14.1335 20ZM14.1335 15.7327H18.4002C19.2846 15.7321 20.0011 15.0157 20.0004 14.133C20.0017 13.2503 19.2853 12.534 18.4008 12.5327H14.1341C13.2497 12.5334 12.5332 13.2497 12.5339 14.1324C12.5332 15.0157 13.249 15.7321 14.1335 15.7327Z"
        fill="#ECB22E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 14.1331C3.99935 15.0158 4.7158 15.7321 5.60026 15.7328C6.48472 15.7321 7.20118 15.0158 7.20052 14.1331V12.5334H5.60026C4.7158 12.5341 3.99935 13.2504 4 14.1331ZM8.26671 14.1331V18.3998C8.2654 19.2825 8.98186 19.9988 9.86632 20.0001C10.7508 19.9995 11.4672 19.2831 11.4666 18.4004V14.1344C11.4679 13.2517 10.7514 12.5354 9.86697 12.5341C8.98186 12.5341 8.26606 13.2504 8.26671 14.1331Z"
        fill="#E01E5A"
      />
    </svg>
  );
};
